<template>
    <v-dialog
      v-model="isFailured"
      persistent
      max-width="550"
    >
      <v-card>
         <v-card-text class="text-center">
           <div><v-icon class="my-5" color="red" x-large>mdi-alert</v-icon></div>
          ご迷惑おかけしております。<br>
          登録に失敗しました。<br>
          しばらくお時間をおいてから再度お試しいただきますようお願いいたします。<br>
          エラーメッセージ：<br>
          {{message}}<br>
          エラー詳細：<br>
          {{detail}}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="teal darken-1"
            rounded
            block
            @click="failureDialog()"
            class="white--text mb-5"
          >
            {{ buttonName }}戻る
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
export default {
    props:["failureUrl", "message", "detail"],
    data: () => ({
        isFailured: false,
        buttonName: ''
    }),
    methods: {
      failureDialog() {
          this.isFailured = false
          this.$router.push(this.failureUrl)
      },
      open() {
        this.isFailured = true;
        if (this.failureUrl == '/mymachinelist') {
          this.buttonName = "マイ機器一覧へ"
        } else {
          this.buttonName = "マイページへ"
        }

      }
    }
}
</script>

